import { render, staticRenderFns } from "./AlertAddForm.vue?vue&type=template&id=1e456f5b&scoped=true"
import script from "./AlertAddForm.vue?vue&type=script&lang=js"
export * from "./AlertAddForm.vue?vue&type=script&lang=js"
import style0 from "./AlertAddForm.vue?vue&type=style&index=0&id=1e456f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e456f5b",
  null
  
)

export default component.exports